import { render } from "./Add.vue?vue&type=template&id=218f172e&scoped=true&bindings={\"submit\":\"options\"}"
import script from "./Add.vue?vue&type=script&lang=js"
export * from "./Add.vue?vue&type=script&lang=js"

import "./Add.vue?vue&type=style&index=0&id=218f172e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-218f172e"

export default script